// prettier-ignore
export const PUBLIC_EN_US_TRANSLATIONS = {
  "public.logIn.header": "Welcome to the Instacart Retailer Platform",
  "public.logIn.form.fields.email.placeholder": "Email",
  "public.logIn.form.fields.email.error.required": "Email can't be blank",
  "public.logIn.form.fields.email.error.pattern": "Invalid Email",
  "public.logIn.form.fields.password.placeholder": "Password",
  "public.logIn.form.fields.password.error.required": "Password can't be blank",
  "public.logIn.form.fields.password.error.minLength": "Password must be at least 8 characters long",
  "public.logIn.form.fields.reCaptchaToken.error.required": "Please complete the reCAPTCHA.",
  "public.logIn.form.error.invalidCredentials": "Invalid Credentials",
  "public.logIn.form.error.disabledAccount": "Account is disabled. Please contact support.",
  "public.logIn.form.error.captchaFailed": "Invalid reCAPTCHA value. Please refresh and try again.",
  "public.logIn.form.error.common": "Login Failed",
  "public.logIn.form.submit": "Login",
  "public.logIn.forgotPasswordDetail": "Forgot your password?",
  "public.logIn.backToEmail": "Back to email",
  "public.logIn.loggingInWithEmail": "Logging in as {email}",
  "public.logIn.forgotPasswordAction": "Click here",
  "public.logIn.signUpDetail": "Don't have an account? ",
  "public.logIn.signUpAction": "Sign up",
  "public.logIn.sessionExpired": "Your session has expired. Please log in again.",
  "public.logIn.dev.message": "This is the dev environment to access your development and testing data. ",
  "public.createAccount.header": "Create your account",
  "public.createAccount.form.fields.email.placeholder": "Email",
  "public.createAccount.form.fields.email.error.required": "Email can't be blank",
  "public.createAccount.form.fields.email.error.pattern": "Invalid Email",
  "public.createAccount.form.fields.givenName.placeholder": "Name",
  "public.createAccount.form.fields.givenName.error.required": "Name can't be blank",
  "public.createAccount.form.fields.surname.placeholder": "Last Name",
  "public.createAccount.form.fields.surname.error.required": "Last Name can't be blank",
  "public.createAccount.form.fields.phoneNumber.placeholder": "Phone Number",
  "public.createAccount.form.fields.phoneNumber.error.required": "Phone Number can't be blank",
  "public.createAccount.form.fields.phoneNumber.error.pattern": "Invalid Phone Number",
  "public.createAccount.form.fields.password.placeholder": "Password",
  "public.createAccount.form.fields.password.error.required": "Password can't be blank",
  "public.createAccount.form.fields.password.error.minLength": "Password must be at least 8 characters long",
  "public.createAccount.form.fields.confirmPassword.placeholder": "Confirm Password",
  "public.createAccount.form.fields.confirmPassword.error.validate": "Passwords must match",
  'public.createAccount.form.error.insecurePassword': 'Please pick a more secure password',
  'public.createAccount.form.error.existingEmail': 'An account with that email already exists',
  'public.createAccount.form.error.captchaFailed': "Invalid reCAPTCHA value. Please refresh and try again.",
  "public.createAccount.form.error.common": "Sign Up Failed",
  "public.createAccount.form.submit": "Create your account",

  "public.accountSetup.header": "Create your account",
  "public.accountSetup.content.success": "Success - your account has been created!",
  "public.accountSetup.successAction": "Continue",
  "public.accountSetup.content.error.expiredToken": "Sorry - your account setup token is expired. Please try again!",
  "public.accountSetup.content.error.notFound": "Sorry - your account setup token is invalid. Please try again!",
  "public.accountSetup.content.error.insecurePassword": "Password is too easy to guess. Please try a more unique password (at least 8 characters long).",
  "public.accountSetup.content.error.common": "Sorry - we were unable to set up your account. Please try again!",
  "public.accountSetup.errorAction": "Send Me Another Account Setup Email",

  "public.authService.callback.header": "Logging in...",

  "public.requestAccountSetup.header": "Request Account Setup Email",
  "public.requestAccountSetup.form.fields.email.placeholder": "Email",
  "public.requestAccountSetup.form.fields.email.error.required": "Email can't be blank",
  "public.requestAccountSetup.form.fields.email.error.pattern": "Invalid Email",
  "public.requestAccountSetup.form.error.emailNotFound": "No account matches that email.",
  "public.requestAccountSetup.form.error.common": "Account Setup Email Request Failed.",
  "public.requestAccountSetup.form.submit": "Send Email",

  "public.requestEmailVerification.header": "Verify your email",
  "public.requestEmailVerification.form.fields.email.placeholder": "Email",
  "public.requestEmailVerification.form.fields.email.error.required": "Email can't be blank",
  "public.requestEmailVerification.form.fields.email.error.pattern": "Invalid Email",
  "public.requestEmailVerification.form.error.emailNotFound": "No account matches that email.",
  "public.requestEmailVerification.form.error.captchaFailed": "Invalid reCAPTCHA value. Please refresh and try again.",
  "public.requestEmailVerification.form.error.common": "Verification Email Request Failed.",
  "public.requestEmailVerification.form.submit": "Send Email",
  "public.pendingEmailVerification.header": "Verify your email",
  "public.pendingEmailVerification.content": "We just sent you an email - please click on the verification link that we sent you in order to activate your account.",
  "public.pendingEmailVerification.requestAction": "Request Another Verification Email",
  "public.emailVerification.header": "Email Verification",
  "public.emailVerification.content.success": "Success - your email has been verified!",
  "public.emailVerification.successAction": "Continue",
  "public.emailVerification.content.error.expiredToken": "Sorry - your verification token is expired. Please try again!",
  "public.emailVerification.content.error.notFound": "Sorry - your verification token is invalid. Please try again!",
  "public.emailVerification.content.error.common": "Sorry - we were unable to verify your email. Please try again!",
  "public.emailVerification.errorAction": "Send Me Another Email",
  "public.passwordReset.header": "Set your new password",
  "public.passwordReset.content.success": "Success - your password has been reset!",
  "public.passwordReset.successAction": "Continue",
  "public.passwordReset.content.error.expiredToken": "Sorry - your password reset token is expired. Please try again!",
  "public.passwordReset.content.error.notFound": "Sorry - your password reset token is invalid. Please try again!",
  "public.passwordReset.content.error.common": "Sorry - we were unable to reset your password. Please try again!",
  "public.passwordReset.errorAction": "Send Me Another Password Reset Email",
  "public.passwordReset.form.fields.password.placeholder": "New Password",
  "public.passwordReset.form.fields.password.error.required": "Password can't be blank",
  "public.passwordReset.form.fields.password.error.minLength": "Password must be at least 8 characters long",
  "public.passwordReset.form.fields.confirmPassword.placeholder": "Confirm Password",
  "public.passwordReset.form.fields.confirmPassword.error.validate": "Passwords must match",
  'public.passwordReset.form.error.insecurePassword': 'Please pick a more secure password',
  "public.passwordReset.form.submit": "Reset Password",
  "public.requestPasswordReset.header": "Reset your password",
  "public.requestPasswordReset.form.fields.email.placeholder": "Email",
  "public.requestPasswordReset.form.fields.email.error.required": "Email can't be blank",
  "public.requestPasswordReset.form.fields.email.error.pattern": "Invalid Email",
  "public.requestPasswordReset.form.error.emailNotFound": "No account matches that email.",
  "public.requestPasswordReset.form.error.captchaFailed": "Invalid reCAPTCHA value. Please refresh and try again.",
  "public.requestPasswordReset.form.error.common": "Password Reset Request Failed.",
  "public.requestPasswordReset.form.submit": "Send Email",
  "public.pendingPasswordReset.header": "Reset your password",
  "public.pendingPasswordReset.content": "We just sent you an email - please click on the reset link that we sent you in order to reset the password for your account.",
  "public.pendingPasswordReset.requestAction": "Request Another Password Reset Email",
} as const
